import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        VCard,
        { staticClass: "audiencias" },
        [
          _c(
            VCardText,
            [
              _vm.is_audience
                ? _c(
                    "div",
                    { staticClass: "form--row" },
                    [
                      _c(
                        VCol,
                        { staticClass: "pb-0", attrs: { cols: "12" } },
                        [
                          _c("label", { staticClass: "font-weight-bold" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("aud.config.form_images.description")
                              )
                            ),
                          ]),
                          _c(VTextarea, {
                            attrs: {
                              filled: "",
                              rouded: "",
                              readonly: "",
                              rows: 2,
                              "hide-details": "auto",
                              value: _vm.info.custom_audience_description,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                VRow,
                [
                  _c(
                    VCol,
                    { staticClass: "pt-0 pr-0" },
                    [
                      _c(
                        "label",
                        { staticClass: "font-weight-bold col-md-12 mb-0 pb-0" },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("aud.config.form_images.new_image"))
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "col-md-12 pt-1" },
                        [
                          _c(VTextarea, {
                            staticClass: "hint-rigth",
                            attrs: {
                              outlined: "",
                              label: _vm.$t(
                                "aud.config.form_images.description_image"
                              ),
                              rows: 2,
                              "hide-details": "auto",
                              max: 1000,
                              hint:
                                _vm.image.description.length +
                                " / 1000 caracteres.",
                              placeholder:
                                "Utiliza objetos, personas, colores, ubicaciones para describir.",
                              "persistent-hint": "",
                            },
                            model: {
                              value: _vm.image.description,
                              callback: function ($$v) {
                                _vm.$set(_vm.image, "description", $$v)
                              },
                              expression: "image.description",
                            },
                          }),
                          _c(
                            "p",
                            { staticClass: "mb-0" },
                            [
                              _c(
                                VIcon,
                                { attrs: { small: "", dense: "" } },
                                [_vm._v("mdi-star-four-points")]
                              ),
                              _c("b", [_vm._v("¿Necesitas ideas?")]),
                              _c("ul", { staticClass: "pl-4" }, [
                                _c("li", [
                                  _vm._v(
                                    "Una habitación de hotel con una cama king size, sábanas blancas y una mesita de noche con una lámpara de lectura. "
                                  ),
                                ]),
                                _c("li", [
                                  _vm._v(
                                    "Un jardín con una fuente de agua, una mesa de picnic y un césped bien cuidado."
                                  ),
                                ]),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        VFlex,
                        { staticClass: "text-center", attrs: { cols: "12" } },
                        [
                          _vm.is_audience
                            ? _c(
                                VBtn,
                                {
                                  staticClass: "default mr-1",
                                  attrs: {
                                    id: "link_list_audiences",
                                    name: "link_list_audiences",
                                    outlined: "",
                                  },
                                  on: { click: _vm.onVolver },
                                },
                                [_vm._v(_vm._s(_vm.$t("btns.back")) + " ")]
                              )
                            : _vm._e(),
                          _c(
                            VBtn,
                            {
                              attrs: { color: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.onGenerateImageFirst()
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "aud.config.form_images.generate_image"
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(VCol, { staticClass: "pl-0" }, [
                    _c(
                      "label",
                      {
                        staticClass:
                          "font-weight-bold col-md-12 mb-0 pt-0 pb-0",
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("aud.config.form_images.image_list"))
                        ),
                      ]
                    ),
                    _c("div", { staticClass: "col-md-12 pt-0 pb-0" }, [
                      _c(
                        "div",
                        {
                          staticClass: "p-4 pb-0",
                          staticStyle: {
                            border: "1px solid #d4d4d4",
                            "border-radius": "15px",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "form-row" },
                            _vm._l(_vm.list_images, function (item) {
                              return _c(
                                "div",
                                { staticClass: "col-md-3 pt-0" },
                                [
                                  !item.download
                                    ? _c(VIcon, [_vm._v("mdi-image-album")])
                                    : _vm._e(),
                                  item.download
                                    ? _c("img", {
                                        staticClass: "image_view",
                                        staticStyle: {
                                          width: "100%",
                                          cursor: "pointer",
                                        },
                                        attrs: { src: item.src },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onViewImage(item)
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                  _c(
                                    VMenu,
                                    {
                                      attrs: {
                                        end: "",
                                        "offset-x": "",
                                        attach: "",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function (ref) {
                                              var on = ref.on
                                              var props = ref.props
                                              return [
                                                _c(
                                                  VBtn,
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        staticStyle: {
                                                          position: "absolute",
                                                          right: "10px",
                                                        },
                                                        attrs: {
                                                          icon: "",
                                                          small: "",
                                                          dense: "",
                                                        },
                                                      },
                                                      "v-btn",
                                                      props,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _c(VIcon, [
                                                      _vm._v(
                                                        "mdi-dots-horizontal"
                                                      ),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _c(
                                        VList,
                                        [
                                          _c(
                                            VListItem,
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onViewImage(item)
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                VListItemIcon,
                                                [
                                                  _c(
                                                    VIcon,
                                                    {
                                                      attrs: {
                                                        small: "",
                                                        dense: "",
                                                      },
                                                    },
                                                    [_vm._v("icon-view")]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                VListItemContent,
                                                [
                                                  _c(VListItemTitle, [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "aud.config.form_images.view"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            VListItem,
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onDownloadImage(
                                                    item
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                VListItemIcon,
                                                [
                                                  _c(
                                                    VIcon,
                                                    {
                                                      attrs: {
                                                        small: "",
                                                        dense: "",
                                                      },
                                                    },
                                                    [_vm._v("icon-download")]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                VListItemContent,
                                                [
                                                  _c(VListItemTitle, [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "aud.config.form_images.download"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            VListItem,
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onDeleteImage(item)
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                VListItemIcon,
                                                [
                                                  _c(
                                                    VIcon,
                                                    {
                                                      attrs: {
                                                        small: "",
                                                        dense: "",
                                                      },
                                                    },
                                                    [_vm._v("icon-delete")]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                VListItemContent,
                                                [
                                                  _c(VListItemTitle, [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "aud.config.form_images.delete"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }),
                            0
                          ),
                        ]
                      ),
                    ]),
                    _c(
                      "div",
                      { staticClass: "col-md-12 pb-0" },
                      [
                        _c(
                          VFlex,
                          { staticClass: "text-center" },
                          [
                            _vm.list_images.length < _vm.list_to_paginate.length
                              ? _c(
                                  VBtn,
                                  {
                                    attrs: {
                                      color: "default",
                                      outlined: "",
                                      small: "",
                                      dense: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.nextImages()
                                      },
                                    },
                                  },
                                  [_vm._v("Ver +8 imágenes ")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "dialogs-component",
        { ref: "modal_imagen", attrs: { width: 850, title: "Imagen" } },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c(
                VFlex,
                { staticClass: "text-center" },
                [
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "1" } },
                        [
                          _c(
                            VMenu,
                            {
                              attrs: { "offset-y": "" },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        VBtn,
                                        _vm._g(
                                          _vm._b(
                                            {
                                              attrs: {
                                                icon: "",
                                                color: "primary",
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c(VIcon, [
                                            _vm._v("mdi-content-cut"),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            },
                            [
                              _c(
                                VList,
                                _vm._l(_vm.resolutions, function (item, index) {
                                  return _c(
                                    VListItem,
                                    {
                                      key: index,
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeResolution(item)
                                        },
                                      },
                                    },
                                    [
                                      _c(VListItemTitle, [
                                        _vm._v(_vm._s(item.name)),
                                      ]),
                                    ],
                                    1
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _c(VFileInput, {
                            staticClass: "canvas-file-input",
                            attrs: {
                              "prepend-icon": "mdi-file-move-outline",
                              accept: "image/png, image/jpeg, image/bmp",
                              label: "File input",
                              primary: "",
                              "hide-input": "",
                            },
                            on: { change: _vm.handleFileChange },
                          }),
                          _c(
                            VBtn,
                            {
                              attrs: { icon: "", color: "primary" },
                              on: {
                                click: function ($event) {
                                  _vm.textEditorVisible = !_vm.textEditorVisible
                                },
                              },
                            },
                            [
                              _c(VIcon, [
                                _vm._v("mdi-format-letter-starts-with"),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            VBtn,
                            {
                              attrs: { icon: "", color: "primary" },
                              on: { click: _vm.DownloadDesign },
                            },
                            [_c(VIcon, [_vm._v("icon-download")])],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { staticClass: "out-of-box", attrs: { cols: "11" } },
                        [
                          _vm.textEditorVisible
                            ? _c(
                                "div",
                                {
                                  staticClass: "text-editor",
                                  attrs: { id: "text-editor" },
                                },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      "hide-details": "",
                                      dense: "",
                                      solo: "",
                                      label: "Texto",
                                    },
                                    on: {
                                      change: _vm.drawText,
                                      keyup: function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        return _vm.drawText($event)
                                      },
                                    },
                                    model: {
                                      value: _vm.texto,
                                      callback: function ($$v) {
                                        _vm.texto = $$v
                                      },
                                      expression: "texto",
                                    },
                                  }),
                                  _c(VCombobox, {
                                    staticClass: "tam-input-text",
                                    attrs: {
                                      dense: "",
                                      solo: "",
                                      items: _vm.tamanosFuente,
                                      label: "Tamaño de fuente",
                                    },
                                    on: { change: _vm.cambiarTamanoFuente },
                                    model: {
                                      value: _vm.tamanoFuente,
                                      callback: function ($$v) {
                                        _vm.tamanoFuente = $$v
                                      },
                                      expression: "tamanoFuente",
                                    },
                                  }),
                                  _c(VSelect, {
                                    staticClass: "tam-input-font",
                                    attrs: {
                                      dense: "",
                                      "hide-details": "",
                                      solo: "",
                                      items: _vm.fuentes,
                                      label: "Fuente",
                                    },
                                    on: { change: _vm.drawText },
                                    model: {
                                      value: _vm.fuente,
                                      callback: function ($$v) {
                                        _vm.fuente = $$v
                                      },
                                      expression: "fuente",
                                    },
                                  }),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.color,
                                        expression: "color",
                                      },
                                    ],
                                    staticClass: "color-input",
                                    attrs: { type: "color" },
                                    domProps: { value: _vm.color },
                                    on: {
                                      change: _vm.drawText,
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.color = $event.target.value
                                      },
                                    },
                                  }),
                                  _c(
                                    VBtn,
                                    {
                                      attrs: { icon: "" },
                                      on: { click: _vm.drawText },
                                    },
                                    [_c(VIcon, [_vm._v("mdi-send")])],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.item_selected.type == "64"
                            ? _c("canvas", {
                                ref: "nameOfCanvas",
                                attrs: {
                                  width: _vm.resolution_x,
                                  height: _vm.resolution_y,
                                },
                              })
                            : _vm._e(),
                        ]
                      ),
                      _c(VCol, { attrs: { cols: "1" } }),
                      _c(
                        VCol,
                        { attrs: { cols: "11" } },
                        [
                          _c(VTextarea, {
                            staticClass: "mt-2",
                            attrs: {
                              filled: "",
                              rouded: "",
                              readonly: "",
                              "hide-details": "auto",
                              rows: 2,
                              value: _vm.item_selected.description,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: "modal_generate",
          attrs: { width: 800, title: "Imagen generada por ChatGPT" },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c(
                VRow,
                [
                  _c(
                    VCol,
                    { staticClass: "pt-0", attrs: { cols: "5" } },
                    [
                      this.localListImagesNew.length === 0
                        ? _c(
                            "div",
                            { staticClass: "form-row" },
                            _vm._l([0, 1, 2, 3], function (i) {
                              return _c(
                                VCol,
                                {
                                  key: i,
                                  staticClass: "mb-1",
                                  attrs: { cols: "6" },
                                },
                                [
                                  _c("div", { staticClass: "square" }, [
                                    _c("div", { staticClass: "content" }),
                                  ]),
                                ]
                              )
                            }),
                            1
                          )
                        : _c(
                            "div",
                            { staticClass: "form-row" },
                            _vm._l(_vm.localListImagesNew, function (item) {
                              return _c(
                                VCol,
                                { key: item.id, attrs: { cols: "6" } },
                                [
                                  !item.download
                                    ? _c(VIcon, [_vm._v("mdi-image-album")])
                                    : _vm._e(),
                                  item.download
                                    ? _c("img", {
                                        staticClass: "image_view mb-1",
                                        staticStyle: {
                                          width: "100%",
                                          cursor: "pointer",
                                        },
                                        attrs: { src: item.src },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onViewImageNew(item)
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                  _c(VMenu, {
                                    attrs: {
                                      end: "",
                                      "offset-x": "",
                                      attach: "",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function (ref) {
                                            var on = ref.on
                                            var props = ref.props
                                            return [
                                              _c(
                                                VBtn,
                                                _vm._g(
                                                  _vm._b(
                                                    {
                                                      staticStyle: {
                                                        position: "absolute",
                                                        right: "10px",
                                                      },
                                                      attrs: {
                                                        icon: "",
                                                        small: "",
                                                        dense: "",
                                                      },
                                                    },
                                                    "v-btn",
                                                    props,
                                                    false
                                                  ),
                                                  on
                                                ),
                                                [
                                                  _c(VHover, {
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function (ref) {
                                                            var hover =
                                                              ref.hover
                                                            return [
                                                              _c(
                                                                VIcon,
                                                                {
                                                                  attrs: {
                                                                    medium: "",
                                                                    color:
                                                                      item.state ===
                                                                        1 &&
                                                                      hover
                                                                        ? "grey"
                                                                        : item.state ===
                                                                            1 &&
                                                                          !hover
                                                                        ? "secondary"
                                                                        : item.state !==
                                                                            1 &&
                                                                          !hover
                                                                        ? "grey"
                                                                        : "light-blue",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.selectItem(
                                                                          item
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        item.state ===
                                                                          1 &&
                                                                          hover
                                                                          ? "mdi-minus-circle"
                                                                          : item.state ===
                                                                              1 &&
                                                                            !hover
                                                                          ? "mdi-check-circle"
                                                                          : item.state !==
                                                                              1 &&
                                                                            !hover
                                                                          ? "mdi-check-circle"
                                                                          : "mdi-check-circle"
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                      _c(VTextarea, {
                        staticClass: "hint-rigth mt-2",
                        attrs: {
                          outlined: "",
                          label: _vm.$t(
                            "aud.config.form_images.description_image"
                          ),
                          rows: 3,
                          "hide-details": "auto",
                          max: 1000,
                          hint:
                            _vm.image.description.length +
                            " / 1000 caracteres.",
                          placeholder:
                            "Utiliza objetos, personas, colores, ubicaciones para describir.",
                          "persistent-hint": "",
                        },
                        model: {
                          value: _vm.image.description,
                          callback: function ($$v) {
                            _vm.$set(_vm.image, "description", $$v)
                          },
                          expression: "image.description",
                        },
                      }),
                      _c(
                        "div",
                        { staticClass: "text-center" },
                        [
                          _c(
                            VBtn,
                            {
                              attrs: { color: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.onGenerateImageAgain()
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "aud.config.form_images.generate_again"
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { staticClass: "pl-0 pt-0", attrs: { cols: "7" } },
                    [
                      _c(
                        VRow,
                        [
                          _c(
                            VCol,
                            [
                              _c(VFlex, { staticClass: "text-center" }, [
                                !_vm.item_selected_new.src
                                  ? _c("div", { staticClass: "square" }, [
                                      _c("div", { staticClass: "content" }),
                                    ])
                                  : _vm._e(),
                                _vm.item_selected_new.type == "64"
                                  ? _c("img", {
                                      attrs: {
                                        width: "100%",
                                        src: _vm.item_selected_new.src,
                                      },
                                    })
                                  : _vm._e(),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }